declare global {
    interface Window {
        dataLayer?: any[];
    }
}

function handleGtmEvent(gtmEventName: string) {
    if (typeof window === 'undefined') return;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: gtmEventName,
    });
}

export { handleGtmEvent };
